import type { JSX, SVGProps } from "react";

const DEFAULT_WIDTH = 24;
const DEFAULT_HEIGHT = 25;

export function BackIcon({
    height = DEFAULT_HEIGHT,
    width = DEFAULT_WIDTH,
    ...rest
}: SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${DEFAULT_WIDTH} ${DEFAULT_HEIGHT}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M4.97314 12.25H19.0269"
                stroke="var(--mantine-color-dark-0)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.4643 5.375L5.18743 11.7806C5.0529 11.8993 4.97583 12.07 4.97583 12.2494C4.97583 12.4288 5.0529 12.5995 5.18743 12.7181L12.4643 19.125"
                stroke="var(--mantine-color-dark-0)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
